/* tslint:disable */
/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const listOrganizations = /* GraphQL */ `
  query ListOrganizations {
    listOrganizations {
      auth0OrganizationId
      id
      name
      createdAt
      services {
        master {
          id
          name
          __typename
        }
        status
        __typename
      }
      specteeContactEmail
      customerContactEmail
      customerContactName
      contractNumber
      maxGroups
      note
      deletedAt
      planData {
        serviceId
        status
        __typename
      }
      __typename
    }
  }
`;
export const listAuthorities = /* GraphQL */ `
  query ListAuthorities {
    listAuthorities {
      name
      displayName
      totalQuantity
      usedQuantity
      __typename
    }
  }
`;
export const listGroups = /* GraphQL */ `
  query ListGroups {
    listGroups {
      auth0OrganizationId
      id
      name
      memberCount
      isDefault
      __typename
    }
  }
`;
export const listGroupsByAuth0OrganizationId = /* GraphQL */ `
  query ListGroupsByAuth0OrganizationId($auth0OrganizationId: ID!) {
    listGroupsByAuth0OrganizationId(auth0OrganizationId: $auth0OrganizationId) {
      auth0OrganizationId
      id
      name
      memberCount
      isDefault
      __typename
    }
  }
`;
export const listUsers = /* GraphQL */ `
  query ListUsers {
    listUsers {
      auth0UserId
      name
      displayName
      email
      authority {
        name
        displayName
        totalQuantity
        usedQuantity
        __typename
      }
      licenses {
        id
        name
        displayName
        serviceMaster {
          id
          name
          __typename
        }
        type
        __typename
      }
      licenseData {
        serviceId
        roleId
        __typename
      }
      groups {
        auth0OrganizationId
        id
        name
        memberCount
        isDefault
        __typename
      }
      adminGroupIds
      createdAt
      __typename
    }
  }
`;
export const listUsersByAuth0OrganizationId = /* GraphQL */ `
  query ListUsersByAuth0OrganizationId($auth0OrganizationId: ID!) {
    listUsersByAuth0OrganizationId(auth0OrganizationId: $auth0OrganizationId) {
      auth0UserId
      name
      displayName
      email
      authority {
        name
        displayName
        totalQuantity
        usedQuantity
        __typename
      }
      licenses {
        id
        name
        displayName
        serviceMaster {
          id
          name
          __typename
        }
        type
        __typename
      }
      licenseData {
        serviceId
        roleId
        __typename
      }
      groups {
        auth0OrganizationId
        id
        name
        memberCount
        isDefault
        __typename
      }
      adminGroupIds
      createdAt
      __typename
    }
  }
`;
export const listAllUsers = /* GraphQL */ `
  query ListAllUsers($filter: UserQueryFilter) {
    listAllUsers(filter: $filter) {
      auth0UserId
      name
      displayName
      status
      email
      authority {
        name
        displayName
        totalQuantity
        usedQuantity
        __typename
      }
      licenseData {
        serviceId
        roleId
        __typename
      }
      groups {
        auth0OrganizationId
        id
        name
        memberCount
        isDefault
        __typename
      }
      adminGroupIds
      createdAt
      __typename
    }
  }
`;
export const listPlans = /* GraphQL */ `
  query ListPlans {
    listPlans {
      auth0OrganizationId
      status
      master {
        id
        displayName
        serviceMaster {
          id
          name
          __typename
        }
        licenses {
          id
          quantity
          __typename
        }
        __typename
      }
      __typename
    }
  }
`;
export const listLicenses = /* GraphQL */ `
  query ListLicenses($filter: LicenseQueryFilter) {
    listLicenses(filter: $filter) {
      auth0OrganizationId
      master {
        id
        name
        displayName
        serviceMaster {
          id
          name
          __typename
        }
        type
        __typename
      }
      planMaster {
        id
        displayName
        serviceMaster {
          id
          name
          __typename
        }
        licenses {
          id
          quantity
          __typename
        }
        __typename
      }
      assignmentCurrent
      assignmentLimit
      __typename
    }
  }
`;
export const listLicensesByAuth0OrganizationId = /* GraphQL */ `
  query ListLicensesByAuth0OrganizationId($auth0OrganizationId: ID!) {
    listLicensesByAuth0OrganizationId(
      auth0OrganizationId: $auth0OrganizationId
    ) {
      auth0OrganizationId
      master {
        id
        name
        displayName
        serviceMaster {
          id
          name
          __typename
        }
        type
        __typename
      }
      planMaster {
        id
        displayName
        serviceMaster {
          id
          name
          __typename
        }
        licenses {
          id
          quantity
          __typename
        }
        __typename
      }
      assignmentCurrent
      assignmentLimit
      __typename
    }
  }
`;
export const listOptionMasters = /* GraphQL */ `
  query ListOptionMasters($filter: OptionMasterQueryFilter) {
    listOptionMasters(filter: $filter) {
      id
      num
      displayName
      description
      licenseId
      licenseType
      planMasterId
      __typename
    }
  }
`;
export const listPlanMasters = /* GraphQL */ `
  query ListPlanMasters($filter: PlanMasterQueryFilter) {
    listPlanMasters(filter: $filter) {
      id
      displayName
      serviceMaster {
        id
        name
        __typename
      }
      licenses {
        id
        quantity
        __typename
      }
      __typename
    }
  }
`;
export const listInvitations = /* GraphQL */ `
  query ListInvitations {
    listInvitations {
      email
      authority {
        name
        displayName
        totalQuantity
        usedQuantity
        __typename
      }
      licenses {
        serviceId
        roleId
        __typename
      }
      groups {
        auth0OrganizationId
        id
        name
        memberCount
        isDefault
        __typename
      }
      createdAt
      __typename
    }
  }
`;
export const listInvitationsByAuth0OrganizationId = /* GraphQL */ `
  query ListInvitationsByAuth0OrganizationId($auth0OrganizationId: ID!) {
    listInvitationsByAuth0OrganizationId(
      auth0OrganizationId: $auth0OrganizationId
    ) {
      email
      authority {
        name
        displayName
        totalQuantity
        usedQuantity
        __typename
      }
      licenses {
        serviceId
        roleId
        __typename
      }
      groups {
        auth0OrganizationId
        id
        name
        memberCount
        isDefault
        __typename
      }
      createdAt
      __typename
    }
  }
`;
export const getOrganization = /* GraphQL */ `
  query GetOrganization {
    getOrganization {
      auth0OrganizationId
      id
      name
      createdAt
      services {
        master {
          id
          name
          __typename
        }
        plan {
          auth0OrganizationId
          status
          master {
            id
            displayName
            __typename
          }
          __typename
        }
        licenses {
          auth0OrganizationId
          master {
            id
            name
            displayName
            type
            __typename
          }
          planMaster {
            id
            displayName
            __typename
          }
          assignmentCurrent
          assignmentLimit
          __typename
        }
        __typename
      }
      specteeContactEmail
      customerContactEmail
      customerContactName
      maxGroups
      note
      contractNumber
      planData {
        serviceId
        status
        __typename
      }
      commonSettings {
        options {
          key
          id
          checked
          usedQuantity
          __typename
        }
        licenses {
          key
          id
          quantity
          usedQuantity
          __typename
        }
        __typename
      }
      serviceSettings {
        serviceId
        startDate
        endDate
        options {
          key
          id
          checked
          usedQuantity
          __typename
        }
        licenses {
          key
          id
          quantity
          usedQuantity
          __typename
        }
        __typename
      }
      __typename
    }
  }
`;
export const getOrganizationByAuth0OrganizationId = /* GraphQL */ `
  query GetOrganizationByAuth0OrganizationId($auth0OrganizationId: ID!) {
    getOrganizationByAuth0OrganizationId(
      auth0OrganizationId: $auth0OrganizationId
    ) {
      auth0OrganizationId
      id
      name
      createdAt
      services {
        master {
          id
          name
          __typename
        }
        plan {
          auth0OrganizationId
          status
          master {
            id
            displayName
            __typename
          }
          __typename
        }
        licenses {
          auth0OrganizationId
          master {
            id
            name
            displayName
            type
            __typename
          }
          planMaster {
            id
            displayName
            __typename
          }
          assignmentCurrent
          assignmentLimit
          __typename
        }
        __typename
      }
      specteeContactEmail
      customerContactEmail
      customerContactName
      maxGroups
      note
      contractNumber
      planData {
        serviceId
        status
        __typename
      }
      commonSettings {
        options {
          key
          id
          checked
          usedQuantity
          __typename
        }
        licenses {
          key
          id
          quantity
          usedQuantity
          __typename
        }
        __typename
      }
      serviceSettings {
        serviceId
        startDate
        endDate
        options {
          key
          id
          checked
          usedQuantity
          __typename
        }
        licenses {
          key
          id
          quantity
          usedQuantity
          __typename
        }
        __typename
      }
      __typename
    }
  }
`;
export const getUser = /* GraphQL */ `
  query GetUser($auth0UserId: ID!) {
    getUser(auth0UserId: $auth0UserId) {
      auth0UserId
      name
      displayName
      email
      authority {
        name
        displayName
        totalQuantity
        usedQuantity
        __typename
      }
      licenses {
        id
        name
        displayName
        serviceMaster {
          id
          name
          __typename
        }
        type
        __typename
      }
      licenseData {
        serviceId
        roleId
        __typename
      }
      groups {
        auth0OrganizationId
        id
        name
        memberCount
        isDefault
        __typename
      }
      adminGroupIds
      createdAt
      __typename
    }
  }
`;
export const getGroup = /* GraphQL */ `
  query GetGroup($id: ID!) {
    getGroup(id: $id) {
      auth0OrganizationId
      id
      name
      memberCount
      isDefault
      __typename
    }
  }
`;
export const getPlanMaster = /* GraphQL */ `
  query GetPlanMaster($planMasterId: ID!) {
    getPlanMaster(planMasterId: $planMasterId) {
      id
      displayName
      serviceMaster {
        id
        name
        __typename
      }
      licenses {
        id
        quantity
        __typename
      }
      __typename
    }
  }
`;
export const getLicense = /* GraphQL */ `
  query GetLicense($id: ID!) {
    getLicense(id: $id) {
      auth0OrganizationId
      master {
        id
        name
        displayName
        serviceMaster {
          id
          name
          __typename
        }
        type
        __typename
      }
      planMaster {
        id
        displayName
        serviceMaster {
          id
          name
          __typename
        }
        licenses {
          id
          quantity
          __typename
        }
        __typename
      }
      assignmentCurrent
      assignmentLimit
      __typename
    }
  }
`;
export const getUserByAuth0OrganizationId = /* GraphQL */ `
  query GetUserByAuth0OrganizationId(
    $auth0OrganizationId: ID!
    $auth0UserId: ID!
  ) {
    getUserByAuth0OrganizationId(
      auth0OrganizationId: $auth0OrganizationId
      auth0UserId: $auth0UserId
    ) {
      auth0UserId
      name
      displayName
      email
      authority {
        name
        displayName
        totalQuantity
        usedQuantity
        __typename
      }
      licenses {
        id
        name
        displayName
        serviceMaster {
          id
          name
          __typename
        }
        type
        __typename
      }
      licenseData {
        serviceId
        roleId
        __typename
      }
      groups {
        auth0OrganizationId
        id
        name
        memberCount
        isDefault
        __typename
      }
      adminGroupIds
      createdAt
      __typename
    }
  }
`;
export const getInvitation = /* GraphQL */ `
  query GetInvitation($email: String!) {
    getInvitation(email: $email) {
      email
      authority {
        name
        displayName
        totalQuantity
        usedQuantity
        __typename
      }
      licenses {
        serviceId
        roleId
        __typename
      }
      groups {
        auth0OrganizationId
        id
        name
        memberCount
        isDefault
        __typename
      }
      createdAt
      __typename
    }
  }
`;
export const getInvitationBasicDetails = /* GraphQL */ `
  query GetInvitationBasicDetails($organizationId: ID!) {
    getInvitationBasicDetails(organizationId: $organizationId) {
      authority {
        name
        displayName
        totalQuantity
        usedQuantity
        __typename
      }
      groups {
        auth0OrganizationId
        id
        name
        memberCount
        isDefault
        __typename
      }
      serviceSettings {
        serviceId
        startDate
        endDate
        options {
          key
          id
          checked
          usedQuantity
          __typename
        }
        licenses {
          key
          id
          quantity
          usedQuantity
          __typename
        }
        __typename
      }
      __typename
    }
  }
`;
export const getInvitationBasicDetailsWithoutOrgId = /* GraphQL */ `
  query GetInvitationBasicDetailsWithoutOrgId {
    getInvitationBasicDetailsWithoutOrgId {
      authority {
        name
        displayName
        totalQuantity
        usedQuantity
        __typename
      }
      groups {
        auth0OrganizationId
        id
        name
        memberCount
        isDefault
        __typename
      }
      serviceSettings {
        serviceId
        startDate
        endDate
        options {
          key
          id
          checked
          usedQuantity
          __typename
        }
        licenses {
          key
          id
          quantity
          usedQuantity
          __typename
        }
        __typename
      }
      __typename
    }
  }
`;
export const getUserDetails = /* GraphQL */ `
  query GetUserDetails {
    getUserDetails {
      organizationId
      organizationName
      userName
      displayName
      email
      __typename
    }
  }
`;
export const getAdminData = /* GraphQL */ `
  query GetAdminData {
    getAdminData {
      activeUserCount
      invitedUserCount
      expiredUserCount
      servicesData {
        serviceId
        licenses {
          key
          id
          quantity
          usedQuantity
          __typename
        }
        __typename
      }
      __typename
    }
  }
`;
